import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import * as FormActions from '@shared/form/store/form.actions';

import { CompaniesFilterComponent } from './filter.component';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompaniesFilterModalComponent implements OnDestroy {
  subscription: Subscription;

  constructor(private store: Store<{}>, private router: Router) {
    this.subscription = this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        filter((event: NavigationEnd) =>
          event.urlAfterRedirects.includes('(modal:filter-companies')
        ),
        tap(() =>
          this.store.dispatch(
            FormActions.formOpen({
              formState: {
                component: CompaniesFilterComponent,
                data: {
                  header: 'Filters',
                  panelClass: 'medium-size-modal'
                }
              }
            })
          )
        )
      )
      .subscribe();
  }

  ngOnDestroy() {
    return !!this.subscription && this.subscription.unsubscribe();
  }
}
